import { fork, all } from 'redux-saga/effects';

import homePageSagas from './containers/HomePage/sagas';
import manualAccessPageSagas from './containers/ManualAccessPage/sagas';
import loginAutomatedPageSagas from './containers/LoginAutomatedPage/sagas';

const sagas = [
  homePageSagas,
  manualAccessPageSagas,
  loginAutomatedPageSagas
  // NOTE: put other app sagas here
];

function* globalSagas() {
  const globalSagasForks = sagas.map((saga) => fork(saga));

  yield all([...globalSagasForks]);
}

export default globalSagas;



// WEBPACK FOOTER //
// ./src/global-sagas.js